import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";
import { Notification } from "../../config/Notification";

export const notificationList = catchAsync(async () => {  
    const data = await httpsCall.get<Notification>(`notification/unread`);
    return data;
});



